import { render, staticRenderFns } from "./ExpireStorage.vue?vue&type=template&id=2ed633a6&scoped=true&"
import script from "./ExpireStorage.vue?vue&type=script&lang=js&"
export * from "./ExpireStorage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed633a6",
  null
  
)

export default component.exports